import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  admins: { data: [], total: 0, page: 0, length: 25, isLoading: false },
  roles: { data: [], total: 0, page: 0, length: 25, isLoading: false },
  groups: { data: [], total: 0, page: 0, length: 25, isLoading: false },
  roleDropdown: [],
  companyGroupDropdown: [],
  companyDropdown: [],
  error: null,
};

const slice = createSlice({
  name: "admins",
  initialState,
  reducers: {
    setAdmins(state, action) {
      state.admins.data = action.payload.data;
      state.admins.total = action.payload.total;
      state.admins.isLoading = false;
    },
    setAdminsPage(state, action) { state.admins.page = action.payload; },
    setAdminsLength(state, action) { state.admins.length = action.payload; state.admins.page = 0; },
    setAdminsLoading(state, action) { state.admins.isLoading = action.payload; },

    setRoles(state, action) {
      state.roles.data = action.payload.data;
      state.roles.total = action.payload.total;
      state.roles.isLoading = false;
    },
    setRolesPage(state, action) { state.roles.page = action.payload; },
    setRolesLength(state, action) { state.roles.length = action.payload; state.roles.page = 0; },
    setRolesLoading(state, action) { state.roles.isLoading = action.payload; },

    setGroups(state, action) {
      state.groups.data = action.payload.data;
      state.groups.total = action.payload.total;
      state.groups.isLoading = false;
    },
    setGroupsPage(state, action) { state.groups.page = action.payload; },
    setGroupsLength(state, action) { state.groups.length = action.payload; state.groups.page = 0; },
    setGroupsLoading(state, action) { state.groups.isLoading = action.payload; },

    setRoleDropdown(state, action) { state.roleDropdown = action.payload || []; },
    setCompanyGroupDropdown(state, action) { state.companyGroupDropdown = action.payload || []; },
    setCompanyDropdown(state, action) { state.companyDropdown = action.payload || []; },

    setError(state, action) { state.error = action.payload; },
  },
});

export const {
  setAdmins, setAdminsPage, setAdminsLength, setAdminsLoading,
  setRoles, setRolesPage, setRolesLength, setRolesLoading,
  setGroups, setGroupsPage, setGroupsLength, setGroupsLoading,
  setRoleDropdown, setCompanyGroupDropdown, setCompanyDropdown,
  setError,
} = slice.actions;

export default slice.reducer;
